// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@font-face {\n  font-family: 'Lilita One';\n  src: url('LilitaOne-Regular.ttf');\n}\n", "",{"version":3,"sources":["inter.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iCAAkD;AACpD","file":"inter.css","sourcesContent":["@font-face {\n  font-family: 'Lilita One';\n  src: url(../fonts/LitataOne/LilitaOne-Regular.ttf);\n}\n"]}]);
// Exports
module.exports = exports;
